export default __webpack_public_path__ + "static/media/api-platform-poster.005a2491.png";